/*
 * @Descripttion: 
 * @version: 
 * @@Company: DCIT-SH
 * @Author: Boyf
 * @Date: 2022-04-26 14:06:19
 * @LastEditors: Boyf
 * @LastEditTime: 2022-11-01 15:12:21
 */
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui';
import 'url-search-params-polyfill';
import 'babel-polyfill';
import has from './directive/rowPermissions.js'
import interFaceF from '@/extend/interface.js'
import start from '@/extend/backlog.js'
import vueAdd from '@/extend/vueAdd.js'
import hasGc from './directive/button.js'
import attach from "@/components/attach";
import cafePdf from 'cafe-pdf'
import 'cafe-pdf/package/cafe-pdf.css'
import gedit from '@/components/editor'
//导入组件包--个人工作台以及包
import '@/extend/vueUse.js'
/*
  vuex状态管理器
*/
import store from './vuex/vuex.js'

//Vue.prototype.$url = 'http://localhost/g3/'
import './assets/css/bem.scss';
import './assets/css/element.css'
import './assets/css/common.scss'

import bus from '@/bus'
Vue.prototype.$bus = bus

// 引入富文本框的组件开始
import VueQuillEditor from 'vue-quill-editor'
// require styles 引入样式
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
// 引入富文本框操作结束

Vue.use(cafePdf)
Vue.use(VueQuillEditor)
Vue.use(ElementUI);
Vue.use(attach);
Vue.component('g-editor',gedit)

Vue.prototype.interFaceF = interFaceF;

import { routerMenu } from '@/router/router-code'
Vue.prototype.routerMenu = routerMenu;
/*
  扩展类
*/

vueAdd()
// console.log('interFace',interFace)

//按钮权限校验

Vue.directive('has-gc', hasGc)

process.env.Mock && require('./mock/mock.js');

// /*
// 	全局声明的组件
// */
// import showTip from "@/components/signTip.vue";
// console.log('===show===',showTip)
// import pdf from 'vue-pdf-cs'

// 样式主题选择
start(Vue, function (VM) {
  return new VM({
    el: '#app',
    router,
    store,
    // pdf,showTip 
    components: { App },
    template: '<App/>',
    render: h => h(App)
  })
})




// WEBPACK FOOTER //
// ./src/main.js